import { FormLabel } from "@mui/material";
import { withStyles } from "tss-react/mui";
import React from "react";
import axios from "axios";

import notificationsStyle from "../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import SaveButton from "../../components/CustomInput/SaveButton";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";

class Checkpayment extends React.Component {
  state = {
    saving: false,
    orderId: null,
    message: "",
    paymentStatus: "",
    paymentInfo: "",
  };

  action = () => {
    this.setState({ saving: true });

    axios
      .get("core/bestellingen/" + this.state.orderId + "/checkpayment")
      .then((response) => {
        if (response.data.data.success) {
          this.setState({
            message: response.data.data.message,
            paymentStatus: response.data.data.paymentStatus,
            paymentInfo: response.data.data.paymentInfo,
            saving: false,
          });
        } else {
          this.setState({
            message: response.data.data.message,
            saving: false,
          });
        }
      })
      .catch((error) => {
        if (jamezzDebugMode) console.log("Checkpayment.js", error);
        this.setState({ saving: false });
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>OrderId:</FormLabel>
            </GridItem>
            <GridItem sm={2} xs={12}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                id={"orderid"}
                inputProps={{
                  type: "text",
                  name: "orderId",
                  onChange: (e) => {
                    this.setState({ orderId: e.target.value });
                  },
                }}
              />
            </GridItem>
            <GridItem>
              <SaveButton buttonText={"send"} onClick={this.action} saving={this.state.saving} />
            </GridItem>
          </GridContainer>
        </CardBody>

        <CardBody>
          <GridContainer>
            <GridItem sm={12} xs={12}>
              Paymentstatus = {this.state.paymentStatus}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem sm={12} xs={12}>
              Message = {this.state.message}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem sm={12} xs={12}>
              <textarea defaultValue={this.state.paymentInfo} style={{ width: "100%", height: "400px" }} />
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}

export default withStyles(Checkpayment, notificationsStyle);
